const base =
  typeof import.meta.env.VITE_LANDING_URL === "string" &&
  import.meta.env.VITE_LANDING_URL.length > 0
    ? (import.meta.env.VITE_LANDING_URL as string).replace(/\/$/, "")
    : "";

/**
 * Base URL of the landing site (no trailing slash). Empty if not configured.
 */
export function getLandingBaseUrl(): string {
  return base;
}

/**
 * Full URL to the Privacy Policy page on the landing site (Spanish).
 */
export function getLandingPrivacyUrl(): string {
  return base ? `${base}/privacy` : "/privacy";
}

/**
 * Full URL to the Terms of Use page on the landing site (Spanish).
 */
export function getLandingTermsUrl(): string {
  return base ? `${base}/terms` : "/terms";
}

/**
 * Full URL to the "How electronic invoicing works" help page on the landing site (Spanish).
 */
export function getLandingHelpElectronicInvoicingUrl(): string {
  return base
    ? `${base}/help/how-electronic-invoicing-works`
    : "/help/how-electronic-invoicing-works";
}
